// extracted by mini-css-extract-plugin
export default {"mainContainer":"EditProjectDocumentModal_mainContainer__Q5Xw0","error":"EditProjectDocumentModal_error__Gc8tI"};